import { useTranslation } from 'react-i18next';
import { useCanAccess } from '@permissions/useFeatures';
import { BetaPill } from '@components/ui/BetaPill/BetaPill';
import { RewindClockIcon } from '@utils/icons';
import styles from './ReplayToggle.module.css';

interface IReplayToggleProps {
  open: boolean;
  onToggle(): void;
}

/** The building card's outlined Replay pill; only for users who can read history. */
export function ReplayToggle({ open, onToggle }: IReplayToggleProps) {
  const { t } = useTranslation();
  const canReplay = useCanAccess('analytics.view');
  if (!canReplay) return null;
  return (
    <button type="button" className={styles.toggle} aria-pressed={open} title={t('monitor.replay.toggle')} onClick={onToggle}>
      <RewindClockIcon />
      {t('monitor.replay.replay')}
      <BetaPill />
    </button>
  );
}
